<template>
  <div class="random-block">
    <h3 class="random-block__title">{{ $t('view.flow.block.random.title') }}</h3>

    <div class="random-block__dragzone">
      <steps-core
        ref="stepsCore"
        v-model="val.blocks"
        :blockId="blockId"
        @singleStepMenu="$emit('singleStepMenu', $event)"
        @del="deleteStep($event, 'blocks')"
      ></steps-core>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: null
    }
  },
  props: ['value', 'blockId'],
  created () {
    this.val = this.value
  },
  methods: {
    onInput () {
      this.$emit('input', this.val)
      this.$store.commit('SET_FLOW_EDIT_FLAG', [this.blockId, true])
      this.$store.commit('SET_EDITED', true)
    },

    deleteStep (id, arrName) {
      for (let i = 0; i < this.val[arrName].length; i++) {
        if (this.val[arrName][i].uuid === id) {
          this.$delete(this.val[arrName], i)
          this.onInput()
          break
        }
      }
    },

    async beforeSave () {
      await this.runHooks('beforeSave')
    },

    async runHooks (hookName) {
      await this.$refs.stepsCore.runHooks(hookName)
    }
  }
}
</script>

<style lang="scss" scoped>
.random-block {
  @include flowElementShadow;
  width: 90%;
  background-color: white;
  border-radius: 7px;
  padding: 1px 10px 10px 14px;

  &__dragzone {
    background-color: #f1f1f1;
    border-radius: 4px;
    padding: 3px 10px 5px 10px;
  }
}
</style>
